// src/components/ui/LoadingSpinner.tsx

import { Spin } from 'antd';

/**
 * 全局加载指示器组件
 * 使用 Ant Design Spin + Tailwind 布局
 */
export const LoadingSpinner = () => {
  return (
    <div className="flex justify-center items-center h-full min-h-50">
      <Spin size="large" />
    </div>
  );
};